import { createContext } from 'react';
import { Classroom } from '@teetsh/app/src/types/classroom';

export const ClassroomsContext = createContext<Classroom[] | undefined>(
  undefined,
);
